import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phoneSetup", "growthObjective", "flagsContainer"]

  static values = {
    flags: { type: Object, default: {} }
  }

  connect() {
    this.evaluate()
  }

  evaluate() {
    const phoneSetup = this.getSelectedPhoneSetup()
    const growthObjectives = this.getSelectedGrowthObjectives()
    const flags = []

    // AI Phone Line: personal cell or no dedicated line
    if (["personal_cell", "no_dedicated_line"].includes(phoneSetup)) {
      flags.push("ai_phone_line")
    }

    // AI Phone Line: better customer communication
    if (growthObjectives.includes("better_customer_communication") && !flags.includes("ai_phone_line")) {
      flags.push("ai_phone_line")
    }

    // Premium Profile: wants more leads or online presence
    if (growthObjectives.includes("get_more_leads") || growthObjectives.includes("improve_online_presence")) {
      flags.push("premium_profile")
    }

    // High priority: no phone + wants leads
    const highPriority = phoneSetup === "no_dedicated_line" && growthObjectives.includes("get_more_leads")

    this.renderFlags(flags, highPriority)
  }

  getSelectedPhoneSetup() {
    const checked = this.element.querySelector('input[name="enrichment[phone_setup]"]:checked')
    return checked ? checked.value : ""
  }

  getSelectedGrowthObjectives() {
    const checked = this.element.querySelectorAll('input[name="enrichment[growth_objectives][]"]:checked')
    return Array.from(checked).map(el => el.value).filter(v => v !== "")
  }

  renderFlags(flags, highPriority) {
    if (!this.hasFlagsContainerTarget) return

    const messages = {
      ai_phone_line: {
        title: "AI Phone Line Opportunity",
        message: "This roofer has no dedicated business phone. Suggest our AI-powered phone line that answers calls 24/7.",
        color: "blue"
      },
      premium_profile: {
        title: "Premium Profile Opportunity",
        message: "This roofer wants more visibility. Suggest upgrading to Premium for featured placement and enhanced profile.",
        color: "purple"
      }
    }

    let html = ""

    if (highPriority) {
      html += this.flagCard(
        "High Priority: AI Phone Line",
        "Strong signal: no phone line + wants leads. This roofer is losing calls. High-priority AI phone line candidate.",
        "red"
      )
    }

    flags.forEach(flag => {
      if (highPriority && flag === "ai_phone_line") return // Already shown as high priority
      const config = messages[flag]
      if (config) {
        html += this.flagCard(config.title, config.message, config.color)
      }
    })

    this.flagsContainerTarget.innerHTML = html
    this.flagsContainerTarget.classList.toggle("hidden", flags.length === 0)
  }

  flagCard(title, message, color) {
    const colors = {
      red: "bg-red-50 border-red-200 text-red-900",
      blue: "bg-blue-50 border-blue-200 text-blue-900",
      purple: "bg-purple-50 border-purple-200 text-purple-900"
    }
    const borderClass = colors[color] || colors.blue

    return `
      <div class="border p-4 ${borderClass} mb-3">
        <p class="font-['Space_Grotesk'] text-sm font-bold mb-1">${title}</p>
        <p class="font-['Inter'] text-sm">${message}</p>
      </div>
    `
  }
}
